import { request } from './request';
import { v4 as generateUUID } from 'uuid';
import { Environment } from 'src/Environment';

const authHeaders = {
  Origin: `${Environment.current?.uiHost}`,
  'Sec-Fetch-Site': 'cross-site',
  'Sec-Fetch-Mode': 'no-cors',
  'Sec-Fetch-Dest': 'empty',
  Referer: `${Environment.current?.uiHost}`,
};

export async function createOrder(mobileNumber, idNumber, totalToBePaid) {
  const body = {
    relatedParty: [
      {
        id: 'ZAONBRDNG',
        name: 'SSO_DID',
        role: 'Customer',
        '@referredType': 'INDIVIDUAL',
      },
    ],
    description: 'SMME Onboarding',
    requestedCompletionDate: new Date(),
    notificationContact: mobileNumber,
    did: 'ZAONBRDNG',
    channel: {
      id: 'ONLINE',
      name: 'www.vodacom.co.za',
    },
    payment: {
      id: 'VisaMasterCard',
      name: 'VisaMasterCard',
    },
    id: generateUUID(),
    orderItem: [
      {
        id: generateUUID(),
        itemPrice: [
          //leave as is - maybe we can use this to specify what products were purchased, but it is uncertain
          {
            description: 'onboarding',
            name: 'onboarding',
            price: {
              taxIncludedAmount: {
                unit: 'ZAR',
                value: 0,
              },
              taxRate: 0,
            },
            unitOfMeasure: 'string',
          },
        ],
        product: {
          id: generateUUID(),
          name: 'onboarding',
          charateristics: [
            {
              name: 'vasAccountNumber',
              value: idNumber,
            },
            {
              name: 'minAmount',
              value: 0,
            },
            {
              name: 'maxAmount',
              value: 0,
            },
            {
              name: 'bsstDue',
              value: 0,
            },
            {
              name: 'msisdn',
              value: mobileNumber,
            },
            {
              name: 'purchaseAmount',
              value: totalToBePaid,
            },
          ],
          productSpecification: {
            id: '7',
            name: 'VODAPAY_ONBOARDING',
          },
        },
      },
    ],
  };

  const res = await request(
    'onboarding/orders',
    {
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify(body),
        headers: authHeaders,
      },
    },
    Environment.current?.orderManagementApiBaseURL,
  );

  if (res?.status === 200) {
    const orderID = res.result[0].orderNo;
    return orderID;
  }
  throw res.errorMessage;
}

export const getTransactionDetails = async (orderId) => {
  const res = await request(
    `payments/web/vodapay-onboarding/payment/credit/details?orderId=${orderId}`,
    {
      fetchOptions: {
        method: 'GET',
      },
    },
    Environment.current?.orderManagementApiBaseURL,
  );

  if (res?.status === 200) {
    const response = res.result;
    return response;
  }
  throw res.errorMessage;
};
